import React from "react";
import { Grid, Box } from "@mui/material";
import { useQuery } from "@apollo/client";
import { PROJECTS } from "../../graphql/gqlProject";
import ProjectCard from "../../components/ProjectCard";
import { useParams } from "react-router-dom";
import { PinwheelLoader } from "../../components/PinwheelLoader";
import { ProjectMeta } from "../../graphql/gqlTypes";

const UserProjects = () => {
  const { userId } = useParams();

  const projectsQuery = useQuery(PROJECTS, {
    variables: { userId },
  });

  if (projectsQuery.loading) return <PinwheelLoader />;
  if (projectsQuery.error) throw Error("Projects loading failed");

  const unsortedProjects: ProjectMeta[] =
    projectsQuery.data?.getProjectsByUserId || [];

  const projects = [...unsortedProjects].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  return (
    <Box
      sx={{
        height: "100%",
        overflowY: "auto",
        px: 4,
      }}
    >
      <Grid container spacing={3} wrap="wrap" paddingY={4}>
        {projects.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </Grid>
    </Box>
  );
};

export default UserProjects;
